import React from "react";

export default function About() {
  return (
    <section name="about" className="py-32 max-w-6xl mx-auto px-6 md:px-12 text-center">
      <h2 className="text-3xl font-semibold mb-6 text-accent">
        About Me
      </h2>
      <p className="opacity-80 leading-relaxed">
        I’m a passionate web and app developer who enjoys creating interactive,
        responsive, and user-centered digital experiences. I love working on
        both the creative and technical sides of development, bringing design
        and functionality together in harmony.
      </p>
    </section>
  );
}
